import 'rxjs/add/operator/filter';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as auth0 from 'auth0-js';
import { environment } from 'environments/environment';

@Injectable()
export class AuthService {
  auth0 = new auth0.WebAuth({
    clientID: environment.auth0.clientID,
    domain: environment.auth0.domain,
    responseType: 'token id_token',
    audience: environment.auth0.audience,
    redirectUri: environment.auth0.callback,
    scope: 'openid profile app_metadata roles name email app_metadata username',
  });

  get userProfile(): any {
    if (this.isAuthenticated()) {
      return JSON.parse(localStorage.getItem('profile'));
    } else {
      return {};
    }
  }

  constructor(public router: Router) {}

  public login(): void {
    this.auth0.authorize({});
  }

  public handleAuthentication(): void {
    this.auth0.parseHash((err, authResult) => {
      console.log(authResult);
      if (authResult && authResult.accessToken && authResult.idToken) {
        window.location.hash = '';
        this.setSession(authResult);
        this.router.navigate(['/home']);
        this.getProfile(() => {});
      } else if (err) {
        this.router.navigate(['/home']);
        console.log(err);
      }
    });
  }

  private setSession(authResult): void {
    // Set the time that the access token will expire at
    const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
  }

  public logout(): void {
    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('profile');
    // Go back to the home route
    this.router.navigate(['/']);
  }

  public isAuthenticated(): boolean {
    // Check whether the current time is past the
    // access token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    // this.getProfile(() => { });
    return new Date().getTime() < expiresAt;
  }

  public getProfile(cb): void {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      throw new Error('Access token must exist to fetch profile');
    }

    const self = this;
    this.auth0.client.userInfo(accessToken, (err, profile) => {
      if (profile) {
        localStorage.setItem('profile', JSON.stringify(profile));
      }
      cb(err, profile);
    });
  }

  public userHasRoles(roles: string[] | string): boolean {
    if (!Array.isArray(roles)) {
      roles = [roles];
    }

    if (this.isAuthenticated()) {
      const profile = JSON.parse(localStorage.getItem('profile'));
      const uRoles = profile['https://ttgt.vn/roles'] || [];
      return roles.every((r) => uRoles.includes(r));
    }
    return false;
  }

  public isAdmin() {
    // return true;
    return (
      this.userProfile &&
      this.userProfile['https://ttgt.vn/roles'] &&
      this.userProfile['https://ttgt.vn/roles'].indexOf('admin') > -1
    );
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/shared/auth/auth.service.ts